import script from "./verifyPhonePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./verifyPhonePopup.vue?vue&type=script&setup=true&lang=ts"

import "./verifyPhonePopup.vue?vue&type=style&index=0&id=1757820f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1757820f"]])

export default __exports__